import {ChainItemType} from "@/model/chain-item-type";

export class ChainUtils {

    public static toMenuImageId(chainId: string) {
        if (chainId === 'chain_woman_free' || chainId === 'chain_yaga') {
            return 'heart';
        } else if (chainId === 'chain_woman_premium') {
            return 'feather';
        } else if (chainId === 'chain_dumbbell') {
            return 'dumbbell';
        } else if (chainId === 'chain_val_free') {
            return 'box_of_chocolates';
        } else if (chainId === 'chain_val_premium') {
            return 'hearts';
        } else if (chainId === 'chain_vip' || chainId === 'chain_platinum_vip' || chainId === 'chain_vip_serra') {
            return 'vip';
        } else if (chainId.includes('chest')) {
            return 'chest';
        } else if (chainId.includes('chain_march_end') || chainId.includes('chain_hru') || chainId.includes('chain_jay') || chainId.includes('chain_snail')) {
            return 'fire';
        }
        return 'star';
    }

    public static getChainItemType(itemIndex: number, currentIndex: number): ChainItemType {
        if (itemIndex === currentIndex) {
            return ChainItemType.CURRENT;
        } else if (itemIndex < currentIndex) {
            return ChainItemType.PAST;
        } else {
            return ChainItemType.FUTURE;
        }

    }
}